/* Auto-generated cache. Refreshed daily by .github/workflows/sync-google-reviews.yml. */
window.WillowGoogleReviewsData = Object.freeze({
  "updatedAt": "2026-11-04T18:41:01.291Z",
  "rating": "4.8",
  "count": "1,590",
  "googleUrl": "https://maps.google.com/?cid=16964345496158131626",
  "summary": [
    "Excellent customer service",
    "High quality vanities",
    "Beautiful design and construction"
  ],
  "reviews": [
    {
      "name": "Linda Landis",
      "date": "3 days ago",
      "text": "The delivery actually came a couple of days early. Both men were great.",
      "url": "https://www.google.com/maps/contrib/100480888770797910307/reviews?hl=en",
      "photos": []
    },
    {
      "name": "sheri davis",
      "date": "4 months ago",
      "text": "I can't say enough good things about Willow Bath! From start to finish, my experience purchasing a vanity was exceptional. The quality of the vanity exceeded my expectations. It is beautiful, solid, and exceptionally well made. You can tell it's built to last. Nathan in customer service made the entire experience outstanding. He was there from the moment I placed my order until everything was complete. He listened carefully to what I wanted and patiently guided me through choosing the perfect vanity top, and I absolutely love the one we selected. Recently, I contacted Willow Bath with another question, and once again Nathan went above and beyond to help me. It's rare to find customer service that is this knowledgeable, responsive, and genuinely committed to making sure customers are happy. I would not hesitate to purchase from Willow Bath again and highly recommend them to anyone looking for a high-quality vanity backed by outstanding customer service. Thank you, Nathan, for making this such a wonderful experience!",
      "url": "https://www.google.com/maps/contrib/108747805516843169684/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Наиля Рузиева",
      "date": "4 months ago",
      "text": "This vanity exceeded our expectations. The sink, countertop, and cabinet fit together perfectly. You can tell everything was carefully checked before ship",
      "url": "https://www.google.com/maps/contrib/111488821502965555256/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Julia Koprivnik",
      "date": "last month",
      "text": "Willow Bath and Vanity have been extremely easy to work with! They are understanding, accommodating and have an all around great company culture. Oh and the vanities are lovely, too! We can’t wait for ours to be installed. I highly recommend working with Willow for your next remodel!",
      "url": "https://www.google.com/maps/contrib/112206236429782942644/reviews?hl=en",
      "photos": []
    },
    {
      "name": "otilia spilca",
      "date": "last month",
      "text": "Very good customer service",
      "url": "https://www.google.com/maps/contrib/109010601012596366082/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Rita Klingenberg",
      "date": "last month",
      "text": "⭐⭐⭐⭐⭐ Outstanding Customer Service! I can't say enough good things about the customer service I received from Willow Bath and Vanity, especially from Alli! I purchased my vanity several years ago, and recently one of the drawer slides broke. Even though it was well past the warranty period, Alli went above and beyond to coordinate the repair and make sure everything was taken care of. Today, my drawer was repaired at absolutely no charge! It's rare these days to find a company that truly stands behind its products and values its customers long after the sale. Alli was wonderful to work with, and I am so appreciative of her efforts. Thank you, Alli, and Willow Bath and Vanity, for such exceptional customer service! You've earned a very happy and loyal customer!",
      "url": "https://www.google.com/maps/contrib/108288757945026228029/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Shelley Moreau",
      "date": "last month",
      "text": "Crew was great!",
      "url": "https://www.google.com/maps/contrib/102071897007283896038/reviews?hl=en",
      "photos": []
    },
    {
      "name": "alexandra schovee",
      "date": "last month",
      "text": "James was awesome and so helpful!",
      "url": "https://www.google.com/maps/contrib/106689522847272454055/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Laurie Zube",
      "date": "last month",
      "text": "We purchased a 42” vanity and we love it! It is absolutely beautiful. So well made and it arrived in perfect condition. I would highly recommend Willow Bath. I would also like to mention that Lee was very helpful in the ordering process making everything go smoothly. We did have one door handle that had a blemish and when I contacted customer service Rob handled getting a replacement out to us within a matter of minutes. Excellent service!",
      "url": "https://www.google.com/maps/contrib/108878758524580101477/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Ryan Newman",
      "date": "last month",
      "text": "Super responsive support!",
      "url": "https://www.google.com/maps/contrib/112297550637397117071/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Andrea Pritchett",
      "date": "last month",
      "text": "I had the best experience working with Olga. The showroom is great and very well stocked but afterwards when I had follow up questions she texted me pictures of everything up close and was so responsive. The guys who helped me at the warehouse when I picked up were equally friendly and helpful. Great experience from start to finish!",
      "url": "https://www.google.com/maps/contrib/115990657484734354803/reviews?hl=en",
      "photos": []
    },
    {
      "name": "Sushmita Prasad",
      "date": "2 months ago",
      "text": "The vanity is of amazing quality, the quartz countertop is well made, we loved the design. Very spacious in storage. Their customer service is excellent, they contacted the shipping company and managed to get the vanity delivered a day early.",
      "url": "https://www.google.com/maps/contrib/105420878155737969620/reviews?hl=en",
      "photos": [
        "https://lh3.googleusercontent.com/grass-cs/AABkmLelGCTIyUSWlBjb2mP-Igo0IH3fPOnTcmFZGEn-RQd1SxxistOs2-Khw2_D32VnIXVhbaG852CHPeFb5wuXTPjN_ovRy-3f5onIBdi-H_zzxfKW_0frwtsKcXzagGx-miUyUNcRz1azmCY6=s160-k-no"
      ]
    }
  ],
  "platforms": {
    "trustpilot": {
      "rating": "4.9",
      "count": "239",
      "updatedAt": "2026-10-26T17:25:54.930Z"
    },
    "judgeme": {
      "rating": "4.93",
      "count": "915",
      "updatedAt": "2026-11-04T18:41:09.574Z"
    }
  }
});
